import { ENVIRONMENT_INITIALIZER, EnvironmentProviders, inject, Provider } from '@angular/core';
import { AuthHttpService } from '@app/core/auth/auth-http-service';

// Note: HTTP client and interceptors are now provided in app.config.ts
// to avoid duplicate provideHttpClient calls which can cause issues

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
  return [
    // Don't provide HTTP client here - it's provided in app.config.ts
    // with the correct interceptor order (JwtInterceptor, JwtErrorInterceptor, errorHandlerInterceptor)
    {
      provide: ENVIRONMENT_INITIALIZER,
      useValue: () => inject(AuthHttpService),
      multi: true,
    },
  ];
};
